<template>
    <div v-if="execute">
        <div id="shopsListWrap">
            <section class="list-of-stores-box mt-5">
                <div class="container">
                    <SearchHeader></SearchHeader>
                    <div class="row category-checkbox-container">
                        <div class="col-lg-3 col-12">
                            <SearchSidebar @search="searchInit" @category="categoryInit"></SearchSidebar>
                        </div>
                        <div class="col-12 col-lg-9 "><!-- content-->
                            <SearchContent :search-prop="search" :category-prop="category"></SearchContent>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
  import SearchHeader from '@/components/SearchHeader'
  import SearchSidebar from '@/components/SearchSidebar'
  import SearchContent from '@/components/SearchContent'

  export default {
    name: 'App',
    components: {
      SearchHeader,
      SearchSidebar,
      SearchContent
    },
    data () {
      return {
        execute: false,
        search: '',
        category: []
      }
    },
    methods: {
      searchInit (value) {
        this.search = value
      },
      categoryInit (value) {
        this.category = value
      }
    },
    created () {
      const wrap = document.getElementById('shopsListWrap')
      if (wrap) {
        this.execute = true
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue